export default __webpack_public_path__ + "static/media/edit.a06f128d.svg";